import styled from 'styled-components';

export const StyledRobotRoutine = styled.div`
  width: 100%;
  margin-bottom: 8px;

  .robot-routine__title {
    ${(props): string => props.theme.fontStyles.redesign.sm.normal}
    text-transform: capitalize;
    margin: 0;
  }

  .robot-routine__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: ${(props): string => props.theme.kcc.spacing.XXS};
  }

  .robot-routine__title--header,
  .robot-routine__count {
    font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.BASE}px;
    font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
  }
`;
